import Axios from "axios";
import { API_URL } from "../config";
import storage from "../utils/storage";
import logoutUser from "../utils/logout-user";

function authRequestInterceptor(config) {
  const token = storage.getToken();
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  config.headers.ContenType = "application/json";
  return config;
}

export const client = Axios.create({
  baseURL: API_URL,
});

client.interceptors.request.use(authRequestInterceptor);
client.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest = error.config.url.includes("login");
      if (!isLoginRequest) {
        return logoutUser();
      }
    }
    return Promise.reject(error);
  },
);
